import { ReactElement, useEffect, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import * as Yup from 'yup';

import { getFollowupTypes } from '../../../api/services/Incidents';
import { ChipSelectOption } from '../../../components/ChipSelect';
import MultipleTypeLinks from '../../../components/MultipleTypeLinks';
import { IncidentFollowUp } from '../../../types/incidents';
import { StyledFormLabel } from '../IncidentForm.styles';

interface FollowupFieldProps {
  defaultValue?: IncidentFollowUp[];
}

export const followupValidation = Yup.array()
  .of(
    Yup.object().shape({
      type: Yup.string().required('Type is required'),
      value: Yup.string().url('Kustomer link must be a vaild url').required('Kustomer link is required'),
    })
  )
  .nullable();

export const FollowupField = ({ defaultValue }: FollowupFieldProps): ReactElement => {
  const [types, setTypes] = useState<ChipSelectOption[]>([]);
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name: 'followUps',
    control,
    defaultValue,
    rules: { required: true },
  });

  useEffect(() => {
    const getAPIData = async () => {
      getFollowupTypes().then((data: ChipSelectOption[]) => {
        setTypes(data);
      });
    };

    getAPIData();
  }, []);

  return (
    <MultipleTypeLinks
      label={<StyledFormLabel>Follow-up</StyledFormLabel>}
      types={types}
      typePlaceholder="Select Type"
      linkPlaceholder="Kustomer link"
      value={field.value}
      onChange={field.onChange}
      error={fieldState.error}
    />
  );
};
